<app-aggregated-amount-item
  name="ストリーム数"
  icon="./assets/universal_music.png"
  amount="{{ (streams$ | async)?.units }}"
  unit="ストリーム数"
  [rate]="(streams$ | async)?.rate"
  link=""
  help="{{
    (selectedArtist$ | async)?.nameMain
  }} のストリーム数（速報値）です。ストリーム数は選択期間内の合計数です。"
  [hasAmount]="(streams$ | async)?.hasUnits"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
